import { apiGet } from "../crm/contactsKit";

// Loaders shared by the settings screens. Each returns plain rows, or [] / null when the call fails.

/** GET /api/organizations/my-organization returns the rows array, not the row. */
export async function loadOrg() {
  const r = await apiGet("/api/organizations/my-organization");
  const d = r?.data;
  return Array.isArray(d) ? d[0] || null : d || null;
}

export async function loadFacilities(params) {
  const r = await apiGet("/api/facilities", params);
  return r?.success ? r.data || [] : [];
}

export async function loadStaff(params) {
  const r = await apiGet("/api/staff", params);
  return r?.success ? r.data || [] : [];
}

/**
 * Which facilities each staff member works at. GET /api/staff has no facilities on its rows,
 * so this asks once per facility (GET /api/staff?facility_id=…). → { [staffId]: [facility, …] }
 */
export async function loadStaffFacilityMap(facilities) {
  const lists = await Promise.all(facilities.map((f) => loadStaff({ facility_id: f.id }).then((rows) => [f, rows])));
  const map = {};
  lists.forEach(([f, rows]) => rows.forEach((s) => { (map[s.id] = map[s.id] || []).push(f); }));
  return map;
}

/** Staff roles the backend accepts (staff_members.role). */
export const STAFF_ROLES = [
  { value: "doctor", label: "Doctor" },
  { value: "nurse", label: "Nurse" },
  { value: "receptionist", label: "Receptionist" },
  { value: "admin", label: "Admin" },
  { value: "lab_technician", label: "Lab technician" },
  { value: "pharmacist", label: "Pharmacist" },
];
export const roleLabel = (value) => STAFF_ROLES.find((r) => r.value === value)?.label || value || "";
